import { WaterDataType } from "../../interface/dataTypeInterface";
// pressure data from https://www.engineeringtoolbox.com/water-vapor-saturation-pressure-d_599.html?vA=30&units=C#

export const waterData: WaterDataType[] = [
  {
    name: "Water Saturation Pressure",
    id: "watersaturationdata001",
    updatedAt: "2022-07-26",
    descriptions: [
      "The saturation vapour pressure is the pressure at which water vapour is in thermodynamic equilibrium with its condensed state. At pressures higher than vapour pressure, water would condense, whilst at lower pressures it would evaporate or sublimate.",
    ],
    data: [
      // temperature degrees celcius, pressure pascal density kg/m\u00b3 viscocity Pas
      {
        temperature: { value: 0, unit: "°C" },
        pressure: { value: 613, unit: "Pa" },
        density: { value: 1002, unit: "kg/m\u00b3" },
        dynamic_viscosity: { value: 0.001778, unit: "Pas" },
      },
      {
        temperature: { value: 1, unit: "°C" },
        pressure: { value: 658, unit: "Pa" },
        density: { value: 1001.8, unit: "kg/m\u00b3" },
        dynamic_viscosity: { value: 0.001721, unit: "Pas" },
      },
      {
        temperature: { value: 2, unit: "°C" },
        pressure: { value: 707, unit: "Pa" },
        density: { value: 1001.6, unit: "kg/m\u00b3" },
        dynamic_viscosity: { value: 0.001667, unit: "Pas" },
      },
      {
        temperature: { value: 3, unit: "°C" },
        pressure: { value: 758, unit: "Pa" },
        density: { value: 1001.4, unit: "kg/m\u00b3" },
        dynamic_viscosity: { value: 0.001615, unit: "Pas" },
      },
      {
        temperature: { value: 4, unit: "°C" },
        pressure: { value: 813, unit: "Pa" },
        density: { value: 1001.2, unit: "kg/m\u00b3" },
        dynamic_viscosity: { value: 0.001565, unit: "Pas" },
      },
      {
        temperature: { value: 5, unit: "°C" },
        pressure: { value: 872, unit: "Pa" },
        density: { value: 1001, unit: "kg/m\u00b3" },
        dynamic_viscosity: { value: 0.001518, unit: "Pas" },
      },
      {
        temperature: { value: 6, unit: "°C" },
        pressure: { value: 935, unit: "Pa" },
        density: { value: 1000.8, unit: "kg/m\u00b3" },
        dynamic_viscosity: { value: 0.001473, unit: "Pas" },
      },
      {
        temperature: { value: 7, unit: "°C" },
        pressure: { value: 1001, unit: "Pa" },
        density: { value: 1000.6, unit: "kg/m\u00b3" },
        dynamic_viscosity: { value: 0.001429, unit: "Pas" },
      },
      {
        temperature: { value: 8, unit: "°C" },
        pressure: { value: 1072, unit: "Pa" },
        density: { value: 1000.4, unit: "kg/m\u00b3" },
        dynamic_viscosity: { value: 0.001388, unit: "Pas" },
      },
      {
        temperature: { value: 9, unit: "°C" },
        pressure: { value: 1147, unit: "Pa" },
        density: { value: 1000.2, unit: "kg/m\u00b3" },
        dynamic_viscosity: { value: 0.001348, unit: "Pas" },
      },
      {
        temperature: { value: 10, unit: "°C" },
        pressure: { value: 1227, unit: "Pa" },
        density: { value: 1000, unit: "kg/m\u00b3" },
        dynamic_viscosity: { value: 0.001311, unit: "Pas" },
      },
      {
        temperature: { value: 11, unit: "°C" },
        pressure: { value: 1312, unit: "Pa" },
        density: { value: 999.7, unit: "kg/m\u00b3" },
        dynamic_viscosity: { value: 0.001274, unit: "Pas" },
      },
      {
        temperature: { value: 12, unit: "°C" },
        pressure: { value: 1402, unit: "Pa" },
        density: { value: 999.5, unit: "kg/m\u00b3" },
        dynamic_viscosity: { value: 0.001239, unit: "Pas" },
      },
      {
        temperature: { value: 13, unit: "°C" },
        pressure: { value: 1497, unit: "Pa" },
        density: { value: 999.2, unit: "kg/m\u00b3" },
        dynamic_viscosity: { value: 0.001206, unit: "Pas" },
      },
      {
        temperature: { value: 14, unit: "°C" },
        pressure: { value: 1598, unit: "Pa" },
        density: { value: 999, unit: "kg/m\u00b3" },
        dynamic_viscosity: { value: 0.001174, unit: "Pas" },
      },
      {
        temperature: { value: 15, unit: "°C" },
        pressure: { value: 1705, unit: "Pa" },
        density: { value: 998.8, unit: "kg/m\u00b3" },
        dynamic_viscosity: { value: 0.001143, unit: "Pas" },
      },
      {
        temperature: { value: 20, unit: "°C" },
        pressure: { value: 2340, unit: "Pa" },
        density: { value: 997.4, unit: "kg/m\u00b3" },
        dynamic_viscosity: { value: 0.001007, unit: "Pas" },
      },
      {
        temperature: { value: 25, unit: "°C" },
        pressure: { value: 3171, unit: "Pa" },
        density: { value: 996, unit: "kg/m\u00b3" },
        dynamic_viscosity: { value: 0.00894, unit: "Pas" },
      },
      {
        temperature: { value: 30, unit: "°C" },
        pressure: { value: 4248, unit: "Pa" },
        density: { value: 994.4, unit: "kg/m\u00b3" },
        dynamic_viscosity: { value: 0.008, unit: "Pas" },
      },
      {
        temperature: { value: 35, unit: "°C" },
        pressure: { value: 5630, unit: "Pa" },
        density: { value: 992.7, unit: "kg/m\u00b3" },
        dynamic_viscosity: { value: 0.0072, unit: "Pas" },
      },
      {
        temperature: { value: 40, unit: "°C" },
        pressure: { value: 7385, unit: "Pa" },
        density: { value: 990.8, unit: "kg/m\u00b3" },
        dynamic_viscosity: { value: 0.00653, unit: "Pas" },
      },
      {
        temperature: { value: 45, unit: "°C" },
        pressure: { value: 9595, unit: "Pa" },
        density: { value: 988.9, unit: "kg/m\u00b3" },
        dynamic_viscosity: { value: 0.00595, unit: "Pas" },
      },
      {
        temperature: { value: 50, unit: "°C" },
        pressure: { value: 12351, unit: "Pa" },
        density: { value: 986.8, unit: "kg/m\u00b3" },
        dynamic_viscosity: { value: 0.00546, unit: "Pas" },
      },
      {
        temperature: { value: 55, unit: "°C" },
        pressure: { value: 15761, unit: "Pa" },
        density: { value: 984.5, unit: "kg/m\u00b3" },
        dynamic_viscosity: { value: 0.00502, unit: "Pas" },
      },
      {
        temperature: { value: 60, unit: "°C" },
        pressure: { value: 19946, unit: "Pa" },
        density: { value: 982.2, unit: "kg/m\u00b3" },
        dynamic_viscosity: { value: 0.00465, unit: "Pas" },
      },
      {
        temperature: { value: 65, unit: "°C" },
        pressure: { value: 25042, unit: "Pa" },
        density: { value: 979.7, unit: "kg/m\u00b3" },
        dynamic_viscosity: { value: 0.00432, unit: "Pas" },
      },
      {
        temperature: { value: 70, unit: "°C" },
        pressure: { value: 31202, unit: "Pa" },
        density: { value: 977.1, unit: "kg/m\u00b3" },
        dynamic_viscosity: { value: 0.00402, unit: "Pas" },
      },
      {
        temperature: { value: 75, unit: "°C" },
        pressure: { value: 38597, unit: "Pa" },
        density: { value: 974.4, unit: "kg/m\u00b3" },
        dynamic_viscosity: { value: 0.00376, unit: "Pas" },
      },
      {
        temperature: { value: 80, unit: "°C" },
        pressure: { value: 47414, unit: "Pa" },
        density: { value: 971.5, unit: "kg/m\u00b3" },
        dynamic_viscosity: { value: 0.00353, unit: "Pas" },
      },
      {
        temperature: { value: 85, unit: "°C" },
        pressure: { value: 57867, unit: "Pa" },
        density: { value: 968.5, unit: "kg/m\u00b3" },
        dynamic_viscosity: { value: 0.00332, unit: "Pas" },
      },
      {
        temperature: { value: 90, unit: "°C" },
        pressure: { value: 70182, unit: "Pa" },
        density: { value: 965.4, unit: "kg/m\u00b3" },
        dynamic_viscosity: { value: 0.00314, unit: "Pas" },
      },
      {
        temperature: { value: 95, unit: "°C" },
        pressure: { value: 84607, unit: "Pa" },
        density: { value: 962.2, unit: "kg/m\u00b3" },
        dynamic_viscosity: { value: 0.00297, unit: "Pas" },
      },
      {
        temperature: { value: 100, unit: "°C" },
        pressure: { value: 101420, unit: "Pa" },
        density: { value: 958.8, unit: "kg/m\u00b3" },
        dynamic_viscosity: { value: 0.00282, unit: "Pas" },
      },
    ],
  },
];
